import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import BookingService from './../../../services/cargobooking.service';
import Pagination from './../../../../shared/components/pagination'
import CustomExpandableTable from './../../../../shared/components/customExpandableTable';
import Util from './../../../../shared/util/util';
import CONSTANT from './../../../../shared/constants/constant';

export default {
  name: 'uploadlogList',
  components: {
    VueElementLoading,
    Pagination,
    CustomExpandableTable
  },
  data: function() {
    return {
      uploadlogList:[],
      viewuploadlogListexcel:[],
      isLoading:false,
      innerTableColumn: [],
      totalCount:0,
      totalCount:0,
      CompanyShortNameArr:[],
      viewuploadlogListcsv:[],
      uploadData:{},
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      filetypedisplay:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      resultCount:0,
      offset:0,
      tableColumn: ['Created Date','Created By','FileName','FileType','Action'],
      tableItems: [],
    }
  },
  computed: {

  },
  mounted() {
    this.getsoftdatauploadlogList();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
        this.offset = (page - 1) *this.pageLimit
      this.getsoftdatauploadlogList()
    },
    groupBy(array, property) {
      var hash = {};
      for (var i = 0; i < array.length; i++) {
        if (!hash[array[i][property]]) hash[array[i][property]] = [];
        hash[array[i][property]].push(array[i]);
      }
      return hash;
    },
    async getsoftdatauploadlogList(){
      try {
        this.isLoading = true;
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
        }
        let result = await BookingService.getuploadlogList(inputPayload)
         this.uploadlogList = result.data.data.rows;
         this.tableItems=result.data.data.rows.map((data)=>{
          return {
            'id':data.id,
            'Created Date':Util.displayDateTimeFormat(data.createddate),
            'Created By':data.createdby,
            'FileName':data.filename,
            'FileType':data.filetype,
            'Action': 'Need To Check1'
          }
        })

        this.isLoading = false;
        this.totalCount = result.data.data.count;
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
     },
     async getCustomTableEvent(event) {
       if (event.actionType == "download"){
          var item = this.uploadlogList.find(item => item.id === event.id);
         this.fileview(item.filename);
       }
       if(event.actionType=="view"){
          this.getviewtableDetails(event.id);
       }
    },
    async getviewtableDetails(logfileid){
      try {
        this.viewuploadlogListexcel = [];
        this.viewuploadlogListcsv = [];
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
          "id": logfileid
        }
        this.isLoading = true;
        let result = await BookingService.getuploadlogList(inputPayload);
        if(result.data.status == "FAILED"){
            this.$alert("Filetype Is Not Defined.",'File Type', "error");
        }
        if(result.data.data.filetype=="CSV"){
           this.filetypedisplay = 1;
           this.viewuploadlogListcsv = result.data.data.csvTableData;
           this.isLoading = false;

         }else{
           this.filetypedisplay = 2;
           this.viewuploadlogListexcel = result.data.data.excelTableData;
           this.isLoading = false;
         }
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
      fileview(index){
        var link = document.createElement('a');
        link.href = index;
        link.setAttribute('target','_blank');
        window.open(index, '_blank');
        link.remove();
        return true;
      },
   }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/Uploadloglist/Uploadloglist.component.js